import React, { useEffect, useState } from "react";
import {
    ConfirmationModal,
    CustomTable,
    DeleteButton,
    EditButton,
    EditForm,
    MessageBox,
    MotionDiv,
    useTitle,
} from "../../components";
import {
    useDeleteApplicantMutation,
    useEditApplicantMutation,
    useGetAllApplicantQuery,
} from "../../store";
import { toastOptions } from "../../utils/error";
import { ToastContainer, toast } from "react-toastify";

const column = ["S.No", "Applicant", "Created At", "Actions"];

const Applicant = () => {
    useTitle("Applicant");
    const [resultPerPage, setResultPerPage] = useState(5);
    const [page, setPage] = useState(1);
    const [modalShow, setModalShow] = useState(false);
    const [id, setId] = useState(null);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);

    const {
        isLoading,
        isError,
        error,
        data,
        refetch
    } = useGetAllApplicantQuery();

    const [
        editApplicant,
        {
            isLoading: isEditLoading,
            isSuccess: isEditSuccess,
            error: editError,
        },
    ] = useEditApplicantMutation();

    const [
        deleteApplicant,
        {
            isLoading: isDeleteLoading,
            isSuccess: isDeleteSuccess,
            isError: isDeleteError,
            error: deleteError,
        },
    ] = useDeleteApplicantMutation();

    const [info, setInfo] = useState({ applicant: "" });

    const inputFieldProps = [
        {
            type: "text",
            col: 12,
            row: 8,
            props: {
                name: "applicant",
                label: "Applicant",
                required: true,
                placeHolder: `Enter Applicant`,
            },
        },
    ];

    const deleteInit = (id) => {
        setId(id);
        setShowConfirmationModal(true);
    };

    const pageHandler = (p) => setPage(p);

    const handleResponse = (i) => {
        setId(data?.applicants[i].id);
        setInfo({
            applicant: data?.applicants[i].applicant  // Set the designation value
        });
        setModalShow(true);
    };

    const submitHandler = (e) => {
        e.preventDefault();
        editApplicant({ data: info, id });
    };

    useEffect(() => {
        if (isDeleteError) {
            toast.error(deleteError.data.error.message, toastOptions);
        }

        if (isDeleteSuccess) {
            toast.success("Applicant Deleted Successfully!", toastOptions);
            setShowConfirmationModal(false);
            refetch();  // Refetch the table data after deletion
        }

        if (isEditSuccess) {
            // toast.success("Designation Updated Successfully!", toastOptions);
            setModalShow(false);
            refetch();
        }
    }, [isDeleteError, isDeleteSuccess, isEditSuccess, deleteError, refetch]);


    useEffect(() => {
        refetch();
    }, [isDeleteSuccess, isEditSuccess, refetch]);

    return (
        <MotionDiv>
            <CustomTable
                loading={isLoading}
                column={column}
                paging={false}
                rowNo={resultPerPage}
                rowProps={{ setResultPerPage }}
                pageProps={{ numOfPages: 1, curPage: 1 }}
                pageHandler={pageHandler}
                search={false}
                isCreateBtn={true}
                createBtnProps={{
                    createURL: "/admin/applicant/add",
                    text: "Applicant",
                }}
            >
                {isError ? (
                    <MessageBox variant="danger">
                        {error?.data?.error?.message}
                    </MessageBox>
                ) : (
                    data?.applicants.map((query, i) => (
                        <tr key={query.id} className="odd">
                            <td className="text-center">{i + 1}</td>
                            <td>{query.applicant}</td>
                            <td>{new Date(query.created_at).toLocaleString()}</td>
                            <td>
                                <EditButton onClick={() => handleResponse(i)} />
                                <DeleteButton onClick={() => deleteApplicant(query.id)} />
                            </td>
                        </tr>
                    ))
                )}
            </CustomTable>

            <EditForm
                title="Edit Applicant"
                data={info}
                setData={setInfo}
                inputFieldProps={inputFieldProps}
                submitHandler={submitHandler}
                successMessage="Applicant Updated Successfully!"
                show={modalShow}
                onHide={() => setModalShow(false)}
                reducerProps={{
                    loadingUpdate: isEditLoading,
                    success: isEditSuccess,
                    error: editError,
                }}
            />
            <ToastContainer />
        </MotionDiv>
    );
};

export default Applicant;
